module.exports = __webpack_public_path__ + "static/media/management-img.4d3b3d87.svg";